import React from 'react'
import blogs from '../data/blogs';
import styled from 'styled-components';
import Title from '../components/Title';
import {MainLayout, InnerLayout} from '../styles/Layouts'


function BlogPage() {
    return (
        <MainLayout>
        <BlogsStyled>
            <Title title={'Blogs'} span={'Blogs'}/>
            <InnerLayout className={'blog'}>
            {
                blogs.map((blog)=>{
                    return <div key={blog.id} className='blog-item'>
                        <div className="image">
                            <img src={blog.image} alt="" />
                        </div>
                        <div className="title">
                            <a href={blog.link}>
                                {blog.title}
                            </a>
                        </div>
                    </div>
                })
            }
            </InnerLayout>
        </BlogsStyled>
        </MainLayout>
    )
}

const BlogsStyled = styled.div`
 .blog{
     display: grid;
     grid-template-columns:repeat(2, 1fr) ;
     grid-column-gap: 2rem;
     grid-row-gap: 3rem;
  
    .blog-item{
       background-color: var(--background-dark-grey);
      padding:1rem 1rem;
      overflow: hidden;
    }


    
     .image{
         width: 100%;
         height: 90%;
         overflow: hidden;
         img{
             width: 100%;
             height: 90%;
             object-fit: cover;
             transition: all .4s ease-in-out;
             &:hover{
                 cursor: pointer;
                 transform:rotate(45deg);
             }
         }
     }
     .title{
         a{
             font-size: 1rem;
             padding: 0.5rem 0;
             color:var(--color-white);
             cursor: pointer;
             transform: all .4s ease-in-out;
             &:hover{
                 color:var(--primary-color);

             }
         }
     }
 }

`

export default BlogPage
